// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__36LAf","shimmer":"styles_shimmer__cAisT"};